import { ReactComponent as SearchIcon } from 'assets/icon/search.svg';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IInputSearchProps {
  wrapperClasses?: string;
  inputClasses?: string;
  placeholder?: string;
  value: string;
  onChange: (data: string) => void;
}
const InputSearch: FC<IInputSearchProps> = ({
  wrapperClasses = '',
  inputClasses = '',
  placeholder = 'Type to search...',
  value = '',
  onChange = () => {},
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex items-center w-full gap-x-1 bg-grey1 md:gap-x-3 ${wrapperClasses} px-4 py-1 rounded-3`}
    >
      <SearchIcon />
      <input
        type="text"
        className={`font-medium w-[100px] md:w-auto md:text-base text-sm outline-none bg-transparent placeholder:text-sm flex-1 p-1 ${inputClasses} `}
        placeholder={t('SEARCH_PLACEHOLDER')}
        value={value}
        onChange={e => onChange(e.target?.value)}
      />
    </div>
  );
};

export default InputSearch;
